export default __webpack_public_path__ + "static/media/alpha-black.b795f26e.svg";